import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AuthContextProvider"] */ "/home/vsts/work/1/s/src/app/_lib/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/app/globals.scss");
